import { render, staticRenderFns } from "./no-empty.vue?vue&type=template&id=21dcd77f&scoped=true"
import script from "./no-empty.vue?vue&type=script&lang=js"
export * from "./no-empty.vue?vue&type=script&lang=js"
import style0 from "./no-empty.vue?vue&type=style&index=0&id=21dcd77f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dcd77f",
  null
  
)

export default component.exports